<template>
  <div class="form-select-user">
    <strong v-if="value" style="margin-right: 6px">{{ value }}</strong>
    <el-button
      type="default"
      plain
      icon="el-icon-search"
      size="mini"
      @click="beginSelectUser"
    ></el-button>
  </div>
</template>
<script>
import emitter from 'element-ui/src/mixins/emitter'
import selectUserDialogMixin from '../mixin/selectUserDialogMixin'
export default {
  name: 'form-select-user',
  props: {
    value: String,
    formValue: Object,
    operLabel: {
      type: String,
      default: '添加'
    }
  },
  mixins: [selectUserDialogMixin, emitter],
  methods: {
    beginSelectUser() {
      //   this.$emit('beginSelectUser')

      this.$baseDialog = this.showSelectUserDialog(
        '选择用户',
        '/user/find',
        {
          query: {
            disabled: JSON.stringify({
              Field: 'disabled',
              ComparePattern: 'EQ',
              Values: [false]
            }),
            SortFields: JSON.stringify([{ Field: 'id', Order: 1 }])
          }
        },
        [
          {
            bind: { label: '操作', prop: 'oper', width: 100 },
            default: {
              component: 'cell-render-vnode',
              bind: {
                vnode: (scope) => {
                  return (
                    <el-button
                      type='primary'
                      size='mini'
                      onClick={() => this.endSelectUser(scope.row)}
                    >
                      {this.operLabel}
                    </el-button>
                  )
                }
              }
            }
          }
        ]
      )
    },
    endSelectUser(row) {
      // this.$emit('input', '张三')
      // this.formValue.uid = '123456'
      this.$emit('input', row.nick_name)
      this.formValue.uid = row.id
      if (this.$baseDialog) {
        this.$baseDialog.close()
      }
    }
  },
  watch: {
    value(newVal) {
      this.dispatch('ElFormItem', 'el.form.change', newVal)
    }
  }
}
</script>
